import * as Yup from "yup";
import React, { Fragment, useEffect } from "react";
import { useFormikContext } from "formik";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  AccountHolderType,
  CaseForms,
  CaseMutationType,
  CaseStepperType,
  CaseSubTypes,
  DeclarationType,
  PersonSex,
  PersonType,
  SupplyUserType,
  SupplyWaterType,
  TipoBollettaRecapito,
  UserRoleEnum
} from "../../../helpers/enums";

import moment from "moment";
import { CaseFormField } from "../CaseGenerator";
import {
  getComuniServiti,
  getCorrectLink,
  getStandardAddressFormat, getValidationObject,
  getValidationRule,
  removeDeletedLayoutFields,
  removeRequiredStep,
  SwitchUser,
  TranslatedText
} from "../../../helpers/helpers";
import getMenuConfig from "../../../helpers/menuConfig";
import DigitalizzazioneDocument from "../custom-steps/custom-digitalizzazione-step/DigitalizzazioneDocument";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";
import CombinedConditions from "../custom-steps/CombinedConditions";

let sign = false;
const { pdfLinks: { casesInfoFognatura } } = getMenuConfig();
// eslint-disable-next-line
const InfoLabel = ({ label = "Test label" }) => {
  return (
    <div className="info-label">
      <span className="gc-icon-functional-attention-2-col">
        <span className="path1"></span>
        <span className="path2"></span>
      </span>
      <p>{label}</p>
    </div>
  );
};

const PlainLabel = ({ label = "Test label" }) => {
  return (
    <div className="plain-label">
      <p>{label}</p>
    </div>
  );
};
const SimpleText = ({ text = "Test text" }) => {
  return (
    <div className="simple-text">
      <span>{text}</span>
    </div>
  );
};
const FatturazioneElettronica = (props) => {
  const { layout, fields } = props;
  const { fields: layoutFields } = layout;
  const { setFieldValue } = useFormikContext();
  const user = useSelector((state) => state.auth);

  // contains true or false if a user was found or not
  const { userFetched } = user;

  // returns actual profile or the impersenation profile field from the user object
  const userProfile = SwitchUser(user);

  // get the user role of type UserRoleEnum
  const role = userProfile.role;
  useEffect(() => {
    setFieldValue('userRole', role)
  }, [role, setFieldValue])

  const isConditionMet = (conditionProps) => {
    if (!conditionProps) {
      return true;
    }
    const conditions = conditionProps;
    if (conditions.length === 0) {
      return true;
    }

    let allowed = false;
    conditions.forEach(condition => {
      if (userFetched && (role === condition.is)) {
        allowed = true;
      }
    });
    return allowed;
  };

  return (
    <Fragment key={layout.title}>
      {layout.title && <h2 className={'case-step-title'}>{layout.title}</h2>}
      {layout.description && <p className={'case-step-description'}>{layout.description}</p>}
      <Row>
        {
          layoutFields && layoutFields.map((item, index) => {
            const gridProps = item.grid;
            const conditionProps = item.condition || null;
            const fieldProps = fields[item.fieldName];
            const conditionMet = isConditionMet(conditionProps);
            return conditionMet && (
              <Col {...gridProps} key={index}>
                {!item.fieldName && <h3 className="form-section-title">{item.text}</h3>}
                {item.fieldName && <CaseFormField {...fieldProps} />}
              </Col>
            )
          })
        }
        {
          layout.content && <div className="col-12">
            <div className={'content'}>{layout.content}</div>
          </div>
        }
      </Row>
    </Fragment>
  );
};
const startEventDataLayer = () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Fognatura, "step": "avvio" }) };
let model = {
  formId: CaseForms.Fognatura,

  formField: {
    // step 1.1
    comuneAllaccio: {
      name: "comuneAllaccio",
      label: (
        <TranslatedText i18nKey="cases.fognatura.step1_1.comuneAllaccio.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step1_1.comuneAllaccio.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      message: true,
      readonly: true,
      type: "suggestions",
      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.comune).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            // via.city = selected.comune;
            // setFieldValue(via.name, "");
            // setFieldValue(numeroCivico.name, "");
            console.log('SELECTED', selected)
            // setFieldValue('fisicaProvincia', selected.provincia);
            // setFieldValue('fisicaCAP', selected.cap);

          }
        }
      },
      onBlur: (value, data, setValue, isSentDataLayer, setIsSentDataLayer) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
        if (!isSentDataLayer) {
          startEventDataLayer();
          setIsSentDataLayer(true);
        }
      },
    },
    via: {
      name: 'via',
      label: <TranslatedText i18nKey="cases.allacciamento.via.label" />,
      placeholder: <TranslatedText i18nKey="cases.allacciamento.via.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.allacciamento.via.required" />,
      type: "egon-address",
      suggestionType: "address",
      city: "",
      onError: (value, setFieldValue) => {
        setFieldValue(via.name, value);
        numeroCivico.readonly = false;
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(via.name, value);
        setFieldValue(numeroCivico.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(via.name, isStreetValid ? components.via : "");
        setFieldValue(numeroCivico.name, components.civico);
        egonCodeResponse.tipo_Indirizzo="puf";
        via.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    numeroCivico: {
      name: 'numeroCivico',
      label: <TranslatedText i18nKey="cases.allacciamento.numero_civico.label" />,
      placeholder: <TranslatedText i18nKey="cases.allacciamento.numero_civico.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.allacciamento.numero_civico.required" />,
      type: 'input'
    },
    tipologiaAllaccio: {
      name: "tipologiaAllaccio",
      label: (
        <TranslatedText i18nKey="cases.fognatura.step1_1.tipologiaAllaccio.label" />
      ),
      type: "select",
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step1_1.tipologiaAllaccio.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="errors.registration.public.fc.required" />
      ),
      textSummaryWithKeyPrefix: 'cases.enums.CaseSubTypes.',
      options: [
        {
          label: <TranslatedText i18nKey={"cases.enums.CaseSubTypes.SEWER"} />,
          value: CaseSubTypes.SEWER,
        },
        {
          label: (
            <TranslatedText i18nKey={"cases.enums.CaseSubTypes.SEWER_EXT"} />
          ),
          value: CaseSubTypes.SEWER_EXT,
        },
      ],
    },

    // step 1.2
    tipoIntestatario: {
      name: "tipoIntestatario",
      type: "switch-radio",
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.NATURAL" />,
          value: PersonType.NATURAL,
          grid: { xs: 12, md: 3 },
        },
        {
          label: <TranslatedText i18nKey="cases.enums.PersonType.LEGAL" />,
          value: PersonType.LEGAL,
          grid: { xs: 12, md: 3 },
        },
      ],
      onSelected: (selected, values, profile, setFieldValue) => {
        setFieldValue(signValue.name, sign)
        if (profile.role !== UserRoleEnum.MUNICIPAL_OPERATOR) {
          let piva = "";
          let fiscalCode = "";
          if (profile.fiscalCode !== "") {
            if (isNaN(Number(profile.fiscalCode))) {
              fiscalCode = profile.fiscalCode;
            } else {
              piva = profile.fiscalCode;
            }
          }
          if (selected === PersonType.NATURAL) {
            values[fisicaNome.name] === "" && setFieldValue(fisicaNome.name, profile.name || "");
            values[fisicaCognome.name] === "" && setFieldValue(fisicaCognome.name, profile.surname || "");
            values[fisicaCodiceFiscale.name] === "" && setFieldValue(fisicaCodiceFiscale.name, fiscalCode || "");
          }
          if (selected === PersonType.LEGAL) {
            values[giuridicaRagioneSociale.name] === '' && setFieldValue(giuridicaRagioneSociale.name, profile.businessName || '');
            values[giuridicaCodiceFiscale.name] === '' && setFieldValue(giuridicaCodiceFiscale.name, fiscalCode || '');
            values[giuridicaPartitaIVA.name] === '' && setFieldValue(giuridicaPartitaIVA.name, piva || '');
            values[giuridicaPartitaIVA2.name] === '' && setFieldValue(giuridicaPartitaIVA2.name, piva || '');
            values[giuridicaName.name] === '' && setFieldValue(giuridicaName.name, profile.name || '');
            values[giuridicaSurname.name] === '' && setFieldValue(giuridicaSurname.name, profile.surname || '');
            values[giuridicaComune.name] === '' && setFieldValue(giuridicaComune.name, profile.legalAddress_city || '');
            values[giuridicaProvincia.name] === '' && setFieldValue(giuridicaProvincia.name, profile.legalAddress_province || '');
            values[giuridicaCAP.name] === '' && setFieldValue(giuridicaCAP.name, profile.legalAddress_postalCode || '');
            values[giuridicaSedeLegaleIndirizzo.name] === '' && setFieldValue(giuridicaSedeLegaleIndirizzo.name, `${profile.legalAddress_street} ${profile.legalAddress_streetNumber}`);
          }
          values[bollettaCellulare.name] === '' && setFieldValue(bollettaCellulare.name, profile.mobilePhoneNumber);
          values[bollettaFisso.name] === '' && setFieldValue(bollettaFisso.name, profile.landlinePhoneNumber);
          values[bollettaEmail.name] === '' && setFieldValue(bollettaEmail.name, profile.email);
          values[bollettaPec.name] === '' && setFieldValue(bollettaPec.name, profile.pec);
          values[bollettaPuntoDiFurnitura.name] === '' && setFieldValue(bollettaPuntoDiFurnitura.name, getStandardAddressFormat("cases.address_suggestion.button_1", values.comuneAllaccio, values.via, values.numeroCivico));
        }
      },
    },
    fisicaNome: {
      name: 'fisicaNome',
      label: <TranslatedText i18nKey="cases.allacciamento.fisica_nome.label" />,
      placeholder: <TranslatedText i18nKey="cases.allacciamento.fisica_nome.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="errors.registration.public.fc.required" />,
      type: 'input',
    },
    fisicaCognome: {
      name: 'fisicaCognome',
      label: <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.label" />,
      placeholder: <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.allacciamento.fisica_cognome.required" />,
      type: 'input',
    },
    fisicaCodiceFiscale: {
      name: "fisicaCodiceFiscale",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCodiceFiscale.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCodiceFiscale.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.errors.codicefiscale_invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      uppercase: true,
    },
    fisicaNatoA: {
      name: "fisicaNatoA",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaNatoA.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaNatoA.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    fisicaDataNascita: {
      name: "fisicaDataNascita",
      label: <TranslatedText i18nKey="cases.richiedi_omaggio.dataNascita.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaDataNascita.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "date"
    },
    fisicaSesso: {
      name: "fisicaSesso",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaSesso.label" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      options: [
        { label: "M", value: PersonSex.M, grid: { xs: 4 } },
        { label: "F", value: PersonSex.F, grid: { xs: 4 } },
      ],
    },
    fisicaIndirizzoResidenza: {
      name: "fisicaIndirizzoResidenza",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaIndirizzoResidenza.required.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaIndirizzoResidenza.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(fisicaIndirizzoResidenza.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(fisicaIndirizzoResidenza.name, value);
        setFieldValue(fisicaComuneResidenza.name, "");
        setFieldValue(fisicaProvincia.name, "");
        setFieldValue(fisicaCAP.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(fisicaIndirizzoResidenza.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(fisicaComuneResidenza.name, components.comune);
        setFieldValue(fisicaProvincia.name, components.provincia);
        setFieldValue(fisicaCAP.name, components.cap);
        egonCodeResponse.tipo_Indirizzo="residenza";
        fisicaIndirizzoResidenza.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    fisicaComuneResidenza: {
      name: "fisicaComuneResidenza",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaComuneResidenza.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaComuneResidenza.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    fisicaProvincia: {
      name: "fisicaProvincia",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaProvincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaProvincia.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    fisicaCAP: {
      name: "fisicaCAP",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCAP.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCAP.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input"
    },
    giuridicaRagioneSociale: {
      name: "giuridicaRagioneSociale",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaRagioneSociale.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaRagioneSociale.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
    },
    giuridicaCodiceFiscale: {
      name: "giuridicaCodiceFiscale",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaCodiceFiscale.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaCodiceFiscale.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      uppercase: true,
    },
    giuridicaPartitaIVA: {
      name: "giuridicaPartitaIVA",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaPartitaIVA.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaPartitaIVA.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaPartitaIVA2: {
      name: "giuridicaPartitaIVA2",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaPartitaIVA.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaPartitaIVA.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaPartitaIVAGrupoCheckbox: {
      name: "giuridicaPartitaIVAGrupoCheckbox",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step1.2.giuridicaPartitaIVAGrupoCheckbox.label" />
      ),
      type: "checkbox",
    },
    giuridicaPartitaIVAGrupo: {
      name: "giuridicaPartitaIVAGrupo",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step1_2.giuridicaPartitaIVAGrupo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaName: {
      name: 'giuridicaName',
      label: <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleName.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required' />,
      type: 'input',
    },
    giuridicaSurname: {
      name: 'giuridicaSurname',
      label: <TranslatedText i18nKey="cases.request_info.fields.rappresentanteLegaleSurname.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey='cases.request_info.errors.required' />,
      type: 'input',
    },
    giuridicaSedeLegaleIndirizzo: {
      name: "giuridicaSedeLegaleIndirizzo",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaSedeLegaleIndirizzo.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.giuridicaSedeLegaleIndirizzo.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(giuridicaSedeLegaleIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(giuridicaSedeLegaleIndirizzo.name, value);
        setFieldValue(giuridicaComune.name, "");
        setFieldValue(giuridicaProvincia.name, "");
        setFieldValue(giuridicaCAP.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(giuridicaSedeLegaleIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(giuridicaComune.name, components.comune);
        setFieldValue(giuridicaProvincia.name, components.provincia);
        setFieldValue(giuridicaCAP.name, components.cap);
        egonCodeResponse.tipo_Indirizzo="residenza";
        giuridicaSedeLegaleIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "1",
    },
    giuridicaComune: {
      name: "giuridicaComune",
      label: <TranslatedText i18nKey="cases.request_info.fields.sedeLegaleComune.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaProvincia: {
      name: "giuridicaProvincia",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaProvincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaProvincia.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    giuridicaCAP: {
      name: "giuridicaCAP",
      label: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCAP.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step1_2.fisicaCAP.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },

    // step 2.1
    codiceDestinatarioPA: {
      name: 'codiceDestinatarioPA',
      label: <TranslatedText i18nKey="cases.voltura.fields.destinario_pa.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    userRole: {
      name: 'userRole',
      type: 'input',
    },
    indirizzoPEC: {
      name: 'indirizzoPEC',
      label: <TranslatedText i18nKey="cases.voltura.fields.email_pec.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.email_pec.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />,
      type: 'input',
    },
    codiceCIG: {
      name: 'codiceCIG',
      label: <TranslatedText i18nKey="cases.voltura.fields.person_type.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    codiceCUP: {
      name: 'codiceCUP',
      label: <TranslatedText i18nKey="cases.voltura.fields.cup_code.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    splitPaymentCat: {
      name: 'splitPaymentCat',
      label: <TranslatedText i18nKey="cases.voltura.fields.split_payment_cat.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    codiceDestinatarioSDI: {
      name: 'codiceDestinatarioSDI',
      label: <TranslatedText i18nKey="cases.voltura.fields.destinario_sdi.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    // step 3.1
    signValue: {
      name: "signValue",
      label: <TranslatedText i18nKey="cases.request_info.fields.sign.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaRecapitoTipo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'radio',
      summaryView: false,
      options: [
        {
          label: <TranslatedText i18nKey="cases.voltura.fields.bolletta_racapito_tipo.label" />,
          value: TipoBollettaRecapito.PRE_ESISTENTE,
          grid: { xs: 12 }
        },
      ],
    },
    bollettaRecapitoNuovoIndirizzo: {
      name: 'bollettaRecapitoTipo',
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'radio',
      summaryView: false,
      onChange: (selected, values, setFieldValue) => {
        setFieldValue(bollettaIndirizzo.name, "");
        setFieldValue(bollettaComune.name, "");
        setFieldValue(bollettaCap.name, "");
        setFieldValue(bollettaProvincia.name, "");
      },
      options: [
        {
          label: <TranslatedText i18nKey="cases.voltura.fields.bolletta_racapito_nuovo.label" />,
          value: TipoBollettaRecapito.NUOVO,
          grid: { xs: 12 }
        },
      ],
    },
    bollettaPuntoDiFurnitura: {
      name: 'bollettaPuntoDiFurnitura',
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'button',
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add('selected');
        document.getElementById(bollettaDatiIntestatario.name).classList.remove("selected");
        const egonOrder = bollettaIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        inputs[0].value = `${values.via}, ${values.numeroCivico}`;
        let egonCodeResponse = {...via.egonCodeResponse};
        egonCodeResponse.tipo_Indirizzo ="recapito";
        bollettaIndirizzo.egonCodeResponse = egonCodeResponse;
        setFieldValue(bollettaIndirizzo.name, `${values.via}, ${values.numeroCivico}`);
        setFieldValue(bollettaComune.name, values.comuneAllaccio);
        setFieldValue(bollettaCap.name, '');
        setFieldValue(bollettaProvincia.name, '');
      }
    },
    bollettaDatiIntestatario: {
      name: 'bollettaDatiIntestatario',
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'button',
      summaryView: false,
      title: <TranslatedText i18nKey="common.select" />,
      onClick: (e, values, setFieldValue) => {
        e.target.classList.add('selected');
        document.getElementById(bollettaPuntoDiFurnitura.name).classList.remove("selected");
        const egonOrder = bollettaIndirizzo.egonOrder;
        const inputs = document.getElementById(egonOrder ? `egon-widget-${egonOrder}` : "egon-widget").getElementsByClassName("autocomplete-input");
        const value = values.tipoIntestatario === PersonType.NATURAL ? values.fisicaIndirizzoResidenza : values.giuridicaSedeLegaleIndirizzo;
        inputs[0].value = value;
        let egonCodeResponse = PersonType.NATURAL ? {...fisicaIndirizzoResidenza.egonCodeResponse} : {...giuridicaSedeLegaleIndirizzo.egonCodeResponse};
        egonCodeResponse.tipo_Indirizzo ="recapito";
        bollettaIndirizzo.egonCodeResponse = egonCodeResponse;
        setFieldValue(bollettaIndirizzo.name, value);
        setFieldValue(bollettaComune.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaComuneResidenza : values.giuridicaComune);
        setFieldValue(bollettaProvincia.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaProvincia : values.giuridicaProvincia);
        setFieldValue(bollettaCap.name, values.tipoIntestatario === PersonType.NATURAL ? values.fisicaCAP : values.giuridicaCAP);
      }
    },
    bollettaIndirizzo: {
      name: 'bollettaIndirizzo',
      label: <TranslatedText i18nKey="cases.voltura.fields.nuovo_indirizzo.indirizzo.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(bollettaIndirizzo.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(bollettaIndirizzo.name, value);
        setFieldValue(bollettaComune.name, "");
        setFieldValue(bollettaCap.name, "");
        setFieldValue(bollettaProvincia.name, "");
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(bollettaIndirizzo.name, isStreetValid ? `${components.via}, ${components.civico}` : '');
        setFieldValue(bollettaComune.name, components.comune || "");
        setFieldValue(bollettaCap.name, components.cap || "");
        setFieldValue(bollettaProvincia.name, components.provincia || "");
        egonCodeResponse.tipo_Indirizzo="recapito";
        bollettaIndirizzo.egonCodeResponse=egonCodeResponse;
      },
      step : "3",
    },
    bollettaComune: {
      name: 'bollettaComune',
      label: <TranslatedText i18nKey="cases.request_info.fields.comune.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input'
    },
    bollettaCap: {
      name: 'bollettaCap',
      label: <TranslatedText i18nKey="cases.voltura.fields.cap.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    bollettaProvincia: {
      name: 'bollettaProvincia',
      label: <TranslatedText i18nKey="cases.request_info.fields.provincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    bollettaNomePresso: {
      name: "bollettaNomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.nome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCognomePresso: {
      name: "bollettaCognomePresso",
      label: <TranslatedText i18nKey="cases.voltura.fields.presso.cognome.label" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    bollettaCellulare: {
      name: 'bollettaCellulare',
      label: <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    bollettaFisso: {
      name: 'bollettaFisso',
      label: <TranslatedText i18nKey="cases.voltura.fields.telefono_fisso.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />,
      type: 'input',
    },
    bollettaEmail: {
      name: 'bollettaEmail',
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },
    bollettaConfirmEmail: {
      name: "bollettaConfirmEmail",
      label: <TranslatedText i18nKey="cases.digitalization.confirm" />,
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
      onCopy: true,
      onPaste: true,
    },
    bollettaPec: {
      name: 'bollettaPec',
      label: <TranslatedText i18nKey="cases.voltura.fields.indirizzo_pec.label" />,
      placeholder: <TranslatedText i18nKey="cases.request_info.fields.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.required" />,
      type: 'input',
    },

    // step 4.1
    datiImmobile_cognomeNomeRecapito: {
      name: "datiImmobile_cognomeNomeRecapito",
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,


      type: "input",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cognomeNomeRecapito.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cognomeNomeRecapito.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cognomeNomeRecapito.required" />,
    },
    datiImmobile_codiceFiscale: {
      name: "datiImmobile_codiceFiscale",
      type: "input",
      label: <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_codiceFiscale.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_codiceFiscale.placeholder" />,
      uppercase: true,
    },
    datiImmobile_partitaIva: {
      name: "datiImmobile_partitaIva",
      type: "input",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_partitaIva.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_partitaIva.placeholder" />,
    },
    datiImmobile_indirizzoCivico: {
      name: "datiImmobile_indirizzoCivico",
      type: "input",
      label: <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_indirizzoCivico.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_indirizzoCivico.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_indirizzoCivico.required" />,
    },
    datiImmobile_comune: {
      name: "datiImmobile_comune",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_comune.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_comune.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_comune.required" />,
      readonly: true,
      message: true,
      type: "suggestions",
      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        if (data && data.length) {
          const [selected] = data.filter(
            (item) =>
              String(item.comune).toLowerCase() === String(value).toLowerCase()
          );
          if (selected) {
            setFieldValue("datiImmobile_provincia", selected.provincia);
            setFieldValue("datiImmobile_cap", selected.cap);
          }
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
      },
    },
    datiImmobile_cap: {
      name: "datiImmobile_cap",
      type: "input",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cap.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cap.placeholder" />,
      invalidErrorMsg: <TranslatedText i18nKey="common.select" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cap.required" />,
    },
    datiImmobile_provincia: {
      name: "datiImmobile_provincia",
      type: "input",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_provincia.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_provincia.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_provincia.required" />,
    },
    datiImmobile_cellulare: {
      name: "datiImmobile_cellulare",
      type: "input",
      label: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cellulare.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cellulare.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_cellulare.required" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
    },
    datiImmobile_fisso: {
      name: "datiImmobile_fisso",
      type: "input",
      label: <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_fisso.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_fisso.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_fisso.required" />,
    },
    datiImmobile_email: {
      name: "datiImmobile_email",
      type: "input",
      label: <TranslatedText i18nKey="cases.allacciamento.step4_1.datiImmobile_email.label" />,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_email.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.fognatura.step4_1.datiImmobile_email.required" />,
      invalidErrorMsg: <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />,
    },

    // step 4.2
    inQualitaDi: {
      name: "inQualitaDi",
      label: '',
      className: "inQualitaDi",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.in_qualita_di" />,
      onChange: (selected, values, setFieldValue) => {
        if (selected !== AccountHolderType.OWNER) {
          setFieldValue(ilSottoscrittoNome.name, '');
          setFieldValue(ilSottoscrittoCognome.name, '');

          setFieldValue(dichiaro_diEssereIntestatario.name, false);
          setFieldValue(dichiaro_diEssereIntestatario_numero.name, '');
          setFieldValue(dichiaro_diEssereIntestatario_data.name, '');

          setFieldValue(dichiaro_rilasciatoPermesso.name, false);
          setFieldValue(dichiaro_rilasciatoPermesso_numero.name, '');
          setFieldValue(dichiaro_rilasciatoPermesso_data.name, '');

          setFieldValue(dichiaro_presentataDia.name, false);
          setFieldValue(dichiaro_presentataDia_numero.name, '');
          setFieldValue(dichiaro_presentataDia_data.name, '');

          setFieldValue(dichiaro_presentataScia.name, false);
          setFieldValue(dichiaro_presentataScia_numero.name, '');
          setFieldValue(dichiaro_presentataScia_data.name, '');

          setFieldValue(dichiaro_dataCostruzioneIdonea.name, false);
          setFieldValue(dichiaro_dataCostruzioneIdonea_data.name, '');
        }
        if (selected !== AccountHolderType.OTHER) {
          setFieldValue(dichiaro_altro.name, '');
        }
        if (selected === AccountHolderType.OWNER) {
          setFieldValue(dichiaro_diEssereIntestatario.name, true);

        }
      },
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.OWNER" />
          ),
          value: AccountHolderType.OWNER,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.TENANT" />
          ),
          value: AccountHolderType.TENANT,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.CONDOMINIUM_ADMIN" />
          ),
          value: AccountHolderType.CONDOMINIUM_ADMIN,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.USUFRUCTUARY" />
          ),
          value: AccountHolderType.USUFRUCTUARY,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.LEGAL_REPRESENTATIVE" />
          ),
          value: AccountHolderType.LEGAL_REPRESENTATIVE,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.enums.AccountHolderType.OTHER" />
          ),
          value: AccountHolderType.OTHER,
          grid: { md: 4 },
        },
      ],
    },
    inQualitaDi_altro: {
      name: "dichiaro_altro",
      type: "input",
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.inQualitaDi_altro.placeholder" />,
    },
    ilSottoscrittoNome: {
      name: 'ilSottoscrittoNome',
      label: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.name.error_message" />,
      type: 'input',
    },
    ilSottoscrittoCognome: {
      name: 'ilSottoscrittoCognome',
      label: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.label" />,
      placeholder: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.placeholder" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.voltura.fields.il_sottoscritto.surname.error_message" />,
      type: 'input',
    },
    dichiaro_diEssereIntestatario: {
      name: "dichiaro_diEssereIntestatario",
      label: <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_diEssereIntestatario.label" />,
      type: "checkbox",
    },
    dichiaro_diEssereIntestatario_numero: {
      name: "dichiaro_diEssereIntestatario_numero",
      type: "input",
      placeholder: `Inserisci numero`,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
    },
    dichiaro_diEssereIntestatario_data: {
      name: "dichiaro_diEssereIntestatario_data",
      type: "date",
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
    },
    dichiaro_rilasciatoPermesso: {
      name: "dichiaro_rilasciatoPermesso",
      label: <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_rilasciatoPermesso.label" />,
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue(dichiaro_rilasciatoPermesso_numero.disabled = true)
          setFieldValue(dichiaro_rilasciatoPermesso_data.disabled = true)
        } else {
          setFieldValue(dichiaro_rilasciatoPermesso_numero.disabled = false)
          setFieldValue(dichiaro_rilasciatoPermesso_data.disabled = false)
        }
      }
    },
    dichiaro_rilasciatoPermesso_numero: {
      name: "dichiaro_rilasciatoPermesso_numero",
      type: "input",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.numero.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
    },
    dichiaro_rilasciatoPermesso_data: {
      name: "dichiaro_rilasciatoPermesso_data",
      type: "date",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
    },
    dichiaro_presentataDia: {
      name: "dichiaro_presentataDia",
      label: <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_presentataDia.label" />,
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue(dichiaro_presentataDia_numero.disabled = true)
          setFieldValue(dichiaro_presentataDia_data.disabled = true)
        } else {
          setFieldValue(dichiaro_presentataDia_numero.disabled = false)
          setFieldValue(dichiaro_presentataDia_data.disabled = false)
        }
      }
    },
    dichiaro_presentataDia_numero: {
      name: "dichiaro_presentataDia_numero",
      type: "input",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.numero.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
    },
    dichiaro_presentataDia_data: {
      name: "dichiaro_presentataDia_data",
      type: "date",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
    },
    dichiaro_presentataScia: {
      name: "dichiaro_presentataScia",
      label: <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_presentataScia.label" />,
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue(dichiaro_presentataScia_numero.disabled = true)
          setFieldValue(dichiaro_presentataScia_data.disabled = true)
        } else {
          setFieldValue(dichiaro_presentataScia_numero.disabled = false)
          setFieldValue(dichiaro_presentataScia_data.disabled = false)
        }
      }
    },
    dichiaro_presentataScia_numero: {
      name: "dichiaro_presentataScia_numero",
      type: "input",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.numero.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_numero" />
    },
    dichiaro_presentataScia_data: {
      name: "dichiaro_presentataScia_data",
      type: "date",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
    },
    dichiaro_dataCostruzioneIdonea: {
      name: "dichiaro_dataCostruzioneIdonea",
      label: (
        <TranslatedText i18nKey="cases.allaciamento.step4.2.dichiaro_dataCostruzioneIdonea.label" />
      ),
      type: "checkbox",
      onChange: (e, values, setFieldValue) => {
        if (e === true) {
          setFieldValue(dichiaro_dataCostruzioneIdonea_data.disabled = true)
          setFieldValue(dichiaro_altro.disabled = true)
        } else {
          setFieldValue(dichiaro_dataCostruzioneIdonea_data.disabled = false)
          setFieldValue(dichiaro_altro.disabled = false)
        }
      }
    },
    dichiaro_dataCostruzioneIdonea_data: {
      name: "dichiaro_dataCostruzioneIdonea_data",
      type: "date",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.datepicker.placeholder" />,
      summaryLabel: <TranslatedText i18nKey="cases.allacciamento.interstatario_data" />
    },
    dichiaro_altro: {
      name: "dichiaro_altro",
      type: "checkbox",
    },
    dichiaro_altro_testo: {
      name: "dichiaro_altro_testo",
      type: "input",
      disabled: true,
      placeholder: <TranslatedText i18nKey="cases.fognatura.step4_2.other.placeholder" />,
    },
    // step 4.3

    tipologiaUso: {
      name: "tipologiaUso",
      label: <TranslatedText i18nKey={"cases.fognatura.step4_3.tipologiaUso.label"} />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      summaryView: false,
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso.tipo.acquedotto" />
          ),
          value: SupplyUserType.AQUEDUCT,
          grid: { md: 3 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso.tipo.pozzo_privato" />
          ),
          value: SupplyUserType.PRIVATE_WELL,
          grid: { md: 3 },
        },
      ],
    },

    tipologiaUso_utenza: {
      name: "tipologiaUso_utenza",
      label: <TranslatedText i18nKey="common.contracts" />,
      placeholder: <TranslatedText i18nKey="cases.contract-select.select-contract" />,
      loading: <TranslatedText i18nKey="cases.contract-select.loading" />,
      noContractFound: <TranslatedText i18nKey="cases.contract-select.no-contract-found" />,
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: 'active-contract-select',
      excludeStatusTypes: ['inactive'],
      onSelected: (selected, values, setFieldValue, setFieldTouched) => {
        setFieldValue("comune", selected.city);
        setFieldValue("integraClientCode", selected.clientCode);
        setFieldValue("contractStreet", selected.street);
        setFieldValue("contractStreetNumber", selected.streetNumber);
        setFieldTouched("comune", false);
        setFieldTouched("contractStreet", false);
        setFieldTouched("contractStreetNumber", false);
      },
    },
    integraClientCode: {
      name: "integraClientCode",
      type: "input",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      label: (
        <TranslatedText
          i18nKey={"cases.fognatura.step4_3.tipologiaUso_utenza.label"}
        />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso_utenza.placeholder" />
      ),
    },

    tipologiaUso_utenza_input: {
      name: "tipologiaUso_utenza_input",
      type: "input",
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      label: (
        <TranslatedText
          i18nKey={"cases.fognatura.step4_3.tipologiaUso_utenza.label"}
        />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso_utenza.placeholder" />
      ),
    },
    tipologiaUso_immissione: {
      name: "tipologiaUso_immissione",
      label: (
        <TranslatedText
          i18nKey={"cases.fognatura.step4_3.tipologiaUso_immissione.label"}
        />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "radio",
      options: [
        {
          label: (
            <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso_immissione.tipo.industriali" />
          ),
          value: SupplyWaterType.INDUSTRIAL,
          grid: { md: 4 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso_immissione.tipo.civile_domestico" />
          ),
          value: SupplyWaterType.DOMESTIC,
          grid: { md: 5 },
        },
        {
          label: (
            <TranslatedText i18nKey="cases.fognatura.step4_3.tipologiaUso_immissione.tipo.civile_non_domestico" />
          ),
          value: SupplyWaterType.NOT_DOMESTIC,
          grid: { md: 3 },
        },
      ],
    },

    // step 5.1

    estremiDelDocumento: {
      name: "estremiDelDocumento",
      label: (
        <TranslatedText i18nKey="cases.fognatura.step5_2.estremiDelDocumento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    estremiDelDocumento1: {
      name: "estremiDelDocumento1",
      label: (
        <TranslatedText i18nKey="cases.fognatura.step5_2.estremiDelDocumento.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },

    // step 6
    //privacy policy

    // step 7
    bollettaAddebitoBancario: {
      name: "bollettaAddebitoBancario",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.bolletta_addebito_bancario.label" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "checkbox",
    },
    cognomeNomeDelConto: {
      name: "cognomeNomeDelConto",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.cognome_del_conto.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.cognome_del_conto.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      labelIcon: <i
        className="gc-icon-thick-info"
        aria-hidden="true"
        style={{ fontSize: "20px" }}
      />,
      infoModalMessage: <TranslatedText i18nKey="cases.businessName.popup.message" />,
      type: "input",
    },
    codiceFiscaleTitolare: {
      name: "codiceFiscaleTitolare",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.codice_fiscale_titolare.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.voltura.fields.codice_fiscale.invalid" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      uppercase: true,
      type: "input",
    },
    indirizzoDomiciliazione: {
      name: "indirizzoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.indirizzo.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "egon-address",
      suggestionType: 'address',
      onError: (value, setFieldValue) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onChange: (setFieldValue, value) => {
        setFieldValue(indirizzoDomiciliazione.name, value);
      },
      onSelect: (components, setFieldValue, egonCodeResponse) => {
        const isStreetValid = (typeof components.civico !== 'undefined') && (typeof components.via !== 'undefined');
        setFieldValue(indirizzoDomiciliazione.name, isStreetValid ? `${components.via}, ${components.civico}, ${components.comune}` : '');
        egonCodeResponse.tipo_Indirizzo="domiciliazione";
        indirizzoDomiciliazione.egonCodeResponse=egonCodeResponse;
      },
      step : "7",
    },
    telefonoDomiciliazione: {
      name: "telefonoDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.telefono.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    cellulareDomiciliazione: {
      name: "cellulareDomiciliazione",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
    },
    bankName: {
      name: "bankName",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.nome_banca.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.nome_banca.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    agencia: {
      name: "agencia",
      label: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.agenzia.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.domicialiazone.agenzia.placeholder" />
      ),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "input",
      readonly: true,
    },
    iban: {
      name: 'iban',
      label: <TranslatedText i18nKey="cases.voltura.iban.label" />,
      labelButton: <TranslatedText i18nKey="cases.voltura.iban.labelButton.validation.text" />,
      invalidErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.not_supported' />),
      requiredErrorMsg: (<TranslatedText i18nKey='cases.request_info.errors.file.required' />),
      modalInfoContent: <TranslatedText i18nKey="cases.voltura.iban.modalInfoContent" />,
      modalInfoButtonText: <TranslatedText i18nKey="cases.voltura.iban.modalInfoButtonText" />,
      relatedInfo: [
        { 'bankName': 'bankName' },
        { 'agency': 'agencia' }
      ],
      type: 'iban',
    },

    // step 8
    idType: {
      name: "idType",
      label: <TranslatedText i18nKey="cases.digitalization.idType.placeholder" />,
      placeholder: (<TranslatedText i18nKey="cases.richiedi_omaggio.idType.placeholder" />),
      requiredErrorMsg: <TranslatedText i18nKey="cases.errors.required" />,
      type: "select",
      options: [
        {
          label: "",
          value: "",
        },
        {
          label: <TranslatedText i18nKey="ID" />,
          value: "ID",
        },
        {
          label: <TranslatedText i18nKey="Passport" />,
          value: "Passport",
        },
        {
          label: <TranslatedText i18nKey="Driving_licence" />,
          value: "Driving_licence",
        },
      ],
    },
    Legittima: {
      name: "Legittima",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.Legittima.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "legittima", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    codiceFiscaleDoc: {
      name: "codiceFiscaleDoc",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codiceFiscaleDoc.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "codiceFiscaleDoc", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    verbale: {
      name: "verbale",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.verbale.label" />
      ),
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "verbale", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    CCIAA: {
      name: "CCIAA",
      label: <TranslatedText i18nKey="cases.request_info.fields.CCIAA.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      prefixFileName: "CCIAA", //this set for analisi acqua
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    ID: {
      name: "ID",
      label: <TranslatedText i18nKey="cases.request_info.fields.ID.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/", //this set for analisi acqua
      // prefixFileName: 'voltura', //this set for analisi acqua
      prefixFileNameFromInternalFiledName: "idType",
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },
    fattura: {
      name: "fattura",
      label: <TranslatedText i18nKey="cases.request_info.fields.Fattura.label" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.not_supported" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.file.required" />
      ),
      type: "s3File",
      customPathS3: "upload/",
      prefixFileName: 'Fattura',
      allowedExtensions: ["application/pdf", "image/jpeg"],
      allowDragAndDrop: false,
      infoUploadModalMessage: (
        <TranslatedText i18nKey="complex.case.file.upload.allowed" />
      ),
    },


  },
};

const {
  formField: {
    // step 1.1
    comuneAllaccio,
    via,
    numeroCivico,
    tipologiaAllaccio,

    // step 1.2
    tipoIntestatario,
    fisicaNome,
    fisicaCognome,
    fisicaCodiceFiscale,
    fisicaNatoA,
    fisicaDataNascita,
    fisicaSesso,
    fisicaComuneResidenza,
    fisicaProvincia,
    giuridicaProvincia,
    fisicaCAP,
    fisicaIndirizzoResidenza,

    giuridicaRagioneSociale,
    giuridicaCodiceFiscale,
    giuridicaPartitaIVA,
    giuridicaPartitaIVA2,
    giuridicaPartitaIVAGrupoCheckbox,
    giuridicaPartitaIVAGrupo,
    giuridicaName,
    giuridicaSurname,
    giuridicaComune,
    giuridicaSedeLegaleIndirizzo,
    giuridicaCAP,


    // step 2.1
    codiceDestinatarioPA,
    userRole,
    indirizzoPEC,
    codiceCIG,
    codiceCUP,
    splitPaymentCat,
    codiceDestinatarioSDI,

    // step 3.1
    signValue,
    bollettaRecapitoTipo,
    bollettaRecapitoNuovoIndirizzo,
    bollettaPuntoDiFurnitura,
    bollettaDatiIntestatario,
    bollettaIndirizzo,
    bollettaComune,
    bollettaCap,
    bollettaProvincia,
    bollettaNomePresso,
    bollettaCognomePresso,
    bollettaFisso,
    bollettaCellulare,
    bollettaEmail,
    bollettaConfirmEmail,
    bollettaPec,

    // step 4.1
    datiImmobile_cognomeNomeRecapito,
    datiImmobile_codiceFiscale,
    datiImmobile_partitaIva,
    datiImmobile_indirizzoCivico,
    datiImmobile_comune,
    datiImmobile_cap,
    datiImmobile_provincia,
    datiImmobile_cellulare,
    datiImmobile_fisso,
    datiImmobile_email,

    // step 4.2
    inQualitaDi,
    inQualitaDi_altro,
    ilSottoscrittoNome,
    ilSottoscrittoCognome,
    dichiaro_diEssereIntestatario,
    dichiaro_diEssereIntestatario_numero,
    dichiaro_diEssereIntestatario_data,
    dichiaro_rilasciatoPermesso,
    dichiaro_rilasciatoPermesso_numero,
    dichiaro_rilasciatoPermesso_data,
    dichiaro_presentataDia,
    dichiaro_presentataDia_numero,
    dichiaro_presentataDia_data,
    dichiaro_presentataScia,
    dichiaro_presentataScia_numero,
    dichiaro_presentataScia_data,
    dichiaro_dataCostruzioneIdonea,
    dichiaro_dataCostruzioneIdonea_data,
    dichiaro_altro,
    // step 4.3
    tipologiaUso,
    tipologiaUso_utenza,
    tipologiaUso_utenza_input,
    integraClientCode,
    tipologiaUso_immissione,

    // step 5.1
    estremiDelDocumento,
    estremiDelDocumento1,

    //step 7
    bollettaAddebitoBancario,
    cognomeNomeDelConto,
    codiceFiscaleTitolare,
    bankName,
    indirizzoDomiciliazione,
    telefonoDomiciliazione,
    cellulareDomiciliazione,
    agencia,
    iban,
    // step 8
    //privacy policy

    //step 9
    Legittima,
    codiceFiscaleDoc,
    verbale,
    CCIAA,
    ID,
    fattura,
    idType,
    // emptyStep
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [comuneAllaccio.name]: "",
  [via.name]: "",
  [numeroCivico.name]: "",
  [tipologiaAllaccio.name]: CaseSubTypes.SEWER,

  // step 1.2
  [tipoIntestatario.name]: PersonType.NATURAL,
  [fisicaNome.name]: "",
  [fisicaCognome.name]: "",
  [fisicaCodiceFiscale.name]: "",
  [fisicaNatoA.name]: "",
  [fisicaDataNascita.name]: "",
  [fisicaSesso.name]: PersonSex.M,
  [fisicaIndirizzoResidenza.name]: "",
  [fisicaComuneResidenza.name]: "",
  [fisicaProvincia.name]: "",
  [giuridicaProvincia.name]: "",
  [fisicaCAP.name]: "",
  [giuridicaRagioneSociale.name]: "",
  [giuridicaCodiceFiscale.name]: "",
  [giuridicaPartitaIVA.name]: "",
  [giuridicaPartitaIVA2.name]: "",
  [giuridicaPartitaIVAGrupoCheckbox.name]: false,
  [giuridicaPartitaIVAGrupo.name]: "",
  [giuridicaName.name]: "",
  [giuridicaSurname.name]: "",
  [giuridicaSedeLegaleIndirizzo.name]: "",
  [giuridicaComune.name]: "",
  [giuridicaProvincia.name]: "",
  [giuridicaCAP.name]: "",

  // step 2.1
  [codiceDestinatarioPA.name]: '',
  [userRole.name]: '',
  [indirizzoPEC.name]: '',
  [codiceCIG.name]: '',
  [codiceCUP.name]: '',
  [splitPaymentCat.name]: '',
  [codiceDestinatarioSDI.name]: '',

  // step 3.1
  [signValue.name]: '',
  [bollettaRecapitoNuovoIndirizzo.name]: TipoBollettaRecapito.NUOVO,
  [bollettaRecapitoTipo.name]: TipoBollettaRecapito.PRE_ESISTENTE,
  [bollettaPuntoDiFurnitura.name]: '',
  [bollettaDatiIntestatario.name]: '',
  [bollettaIndirizzo.name]: '',
  [bollettaComune.name]: '',
  [bollettaCap.name]: '',
  [bollettaProvincia.name]: '',
  [bollettaNomePresso.name]: "",
  [bollettaCognomePresso.name]: "",
  [bollettaFisso.name]: '',
  [bollettaCellulare.name]: '',
  [bollettaEmail.name]: '',
  [bollettaConfirmEmail.name]: "",
  [bollettaPec.name]: '',


  // step 4.1
  [datiImmobile_cognomeNomeRecapito.name]: "",
  [datiImmobile_codiceFiscale.name]: "",
  [datiImmobile_partitaIva.name]: "",
  [datiImmobile_indirizzoCivico.name]: "",
  [datiImmobile_comune.name]: "",
  [datiImmobile_cap.name]: "",
  [datiImmobile_provincia.name]: "",
  [datiImmobile_cellulare.name]: "",
  [datiImmobile_fisso.name]: "",
  [datiImmobile_email.name]: "",

  // step 4.2
  [inQualitaDi.name]: AccountHolderType.OWNER,
  [inQualitaDi_altro.name]: "",
  [ilSottoscrittoNome.name]: '',
  [ilSottoscrittoCognome.name]: '',
  [dichiaro_diEssereIntestatario.name]: true,
  [dichiaro_diEssereIntestatario_numero.name]: "",
  [dichiaro_diEssereIntestatario_data.name]: "",
  [dichiaro_rilasciatoPermesso.name]: false,
  [dichiaro_rilasciatoPermesso_numero.name]: "",
  [dichiaro_rilasciatoPermesso_data.name]: "",
  [dichiaro_presentataDia.name]: false,
  [dichiaro_presentataDia_numero.name]: "",
  [dichiaro_presentataDia_data.name]: "",
  [dichiaro_presentataScia.name]: false,
  [dichiaro_presentataScia_numero.name]: "",
  [dichiaro_presentataScia_data.name]: "",
  [dichiaro_dataCostruzioneIdonea.name]: false,
  [dichiaro_dataCostruzioneIdonea_data.name]: "",
  [dichiaro_altro.name]: "",
  // step 4.3
  [tipologiaUso.name]: SupplyUserType.AQUEDUCT,
  [tipologiaUso_utenza.name]: "",
  [tipologiaUso_utenza_input.name]: "",
  [integraClientCode.name]: "",
  [tipologiaUso_immissione.name]: SupplyWaterType.DOMESTIC,

  // step 5.1
  [estremiDelDocumento.name]: "",
  [estremiDelDocumento1.name]: "",

  // step 6.1
  //privacy policy

  // step 7.1
  [bollettaAddebitoBancario.name]: false,
  [cognomeNomeDelConto.name]: "",
  [codiceFiscaleTitolare.name]: "",
  [bankName.name]: "",
  [indirizzoDomiciliazione.name]: "",
  [telefonoDomiciliazione.name]: "",
  [cellulareDomiciliazione.name]: "",
  [agencia.name]: "",
  [iban.name]: "",

  [Legittima.name]: "",
  [codiceFiscaleDoc.name]: "",
  [verbale.name]: "",
  [CCIAA.name]: "",
  [ID.name]: "",
  [fattura.name]: "",
  [idType.name]: "",


};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.
const getValidationSchema = () => {
  const validationFiscalCode = getValidationRule('fiscalCode');
  const validationFiscalCodeOrVAT = getValidationRule('fiscalCodeOrVAT');
  const validationPhone = getValidationRule('phone');
  const validationEmail = getValidationRule('email');
  const validationNumber = getValidationRule('number');
  const validationBusinessName = getValidationObject("businessName");


  return [
    // step 1.1
    Yup.object().shape({
      [comuneAllaccio.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
      [via.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
      [numeroCivico.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
      [tipologiaAllaccio.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
    }),
    // step 1.2
    Yup.object().shape({
      [tipoIntestatario.name]: Yup.string()
        .oneOf(tipoIntestatario.options.map(option => option.value), <TranslatedText i18nKey="common.errors.notValid" />)
        .required(<TranslatedText i18nKey="cases.request_info.errors.required" />),
      [fisicaNome.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaCognome.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaCodiceFiscale.name]: Yup.string()
        .when([tipoIntestatario.name], {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .matches(validationFiscalCode, { message: <TranslatedText i18nKey="errors.registration.public.fc.match" /> })
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),

      [fisicaNatoA.name]: Yup.string()
        .when([tipoIntestatario.name], {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaDataNascita.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string().required(fisicaDataNascita.requiredErrorMsg),
      }),

      [fisicaSesso.name]: Yup.string()
        .oneOf(fisicaSesso.options.map(option => option.value), <TranslatedText i18nKey="common.errors.notValid" />)
        .required(<TranslatedText i18nKey="cases.request_info.errors.required" />),
      [fisicaComuneResidenza.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaProvincia.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true).max(2, <TranslatedText
              i18nKey="province.length" />)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.NATURAL,
          then: Yup.number()
            .typeError(fisicaCAP.invalidErrorMsg)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [fisicaIndirizzoResidenza.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NATURAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
      }),
      // Persona giuridica
      [giuridicaSedeLegaleIndirizzo.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.NUOVO,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="errors.registration.public.fc.long" />)
      }),

      [giuridicaRagioneSociale.name]: Yup.string().when(tipoIntestatario.name, {
        is: (field) => field === PersonType.LEGAL,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
          .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
          .matches(validationBusinessName.regex
            , {
              message: (
                <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
              ),
            }),
      }),
      [giuridicaCodiceFiscale.name]: Yup.string()
        .when([tipoIntestatario.name, giuridicaPartitaIVA.name], {
          is: (field, giuridicaPartitaIVA) => field === PersonType.LEGAL && !giuridicaPartitaIVA,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short" />)
            .max(16, <TranslatedText i18nKey="errors.registration.public.fc.long" />)
            .matches(validationFiscalCodeOrVAT, { message: giuridicaCodiceFiscale.invalidErrorMsg })
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />)
        }),
      [giuridicaPartitaIVA2.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, giuridicaPartitaIVAGrupoCheckbox) => field === PersonType.LEGAL && giuridicaPartitaIVAGrupoCheckbox,
        then: Yup.string()
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            16,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationFiscalCodeOrVAT, {
            message: giuridicaCodiceFiscale.invalidErrorMsg,
          })
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),

      [giuridicaProvincia.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true).max(2, <TranslatedText
              i18nKey="province.length" />)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
        }),

      [giuridicaName.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input" />)
        }),
      [giuridicaPartitaIVAGrupo.name]: Yup.string().when([tipoIntestatario.name, giuridicaPartitaIVAGrupoCheckbox.name], {
        is: (field, checkbox) => field === PersonType.LEGAL && checkbox === true,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .min(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.short" />
          )
          .max(
            11,
            <TranslatedText i18nKey="errors.registration.public.fc.long" />
          )
          .matches(validationNumber, {
            message: (
              <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            ),
          })
          .required(<TranslatedText i18nKey="common.generic.required.input" />),
      }),

      [giuridicaSurname.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(<TranslatedText i18nKey="common.generic.required.input" />)
        }),
      [giuridicaComune.name]: Yup.string()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
        }),
      [giuridicaCAP.name]: Yup.number()
        .when(tipoIntestatario.name, {
          is: (field) => field === PersonType.LEGAL,
          then: Yup.number().typeError(giuridicaCAP.invalidErrorMsg)
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),

        }),
    }),
    //step 2.1
    Yup.object().shape({

      [giuridicaPartitaIVA.name]: Yup.string()
        .when([tipoIntestatario.name, giuridicaCodiceFiscale.name], {
          is: (field, giuridicaCodiceFiscale) => field === PersonType.LEGAL && !giuridicaCodiceFiscale,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short" />)
            .max(11, <TranslatedText i18nKey="errors.registration.public.fc.long" />)
            .matches(validationNumber, {
              message: <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" />
            })
            .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
        }),

      [codiceDestinatarioPA.name]: Yup.string()
        .when(userRole.name, {
          is: UserRoleEnum.MUNICIPAL_USER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(codiceDestinatarioPA.requiredErrorMsg),
        }),
      [indirizzoPEC.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationEmail, { message: indirizzoPEC.invalidErrorMsg })
    }),
    // step 3.1
    Yup.object().shape({
      [bollettaCellulare.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationPhone, { message: bollettaCellulare.invalidErrorMsg })
        .required(giuridicaCodiceFiscale.requiredErrorMsg),
      [bollettaCap.name]: Yup.number()
        .typeError(bollettaCap.invalidErrorMsg)
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),

      [bollettaEmail.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationEmail, { message: bollettaEmail.invalidErrorMsg })
        .required(bollettaEmail.requiredErrorMsg),

      [bollettaConfirmEmail.name]: Yup.string().when([signValue.name], {
        is: (signValue) => signValue === true,
        then: Yup.string()
          .oneOf(
            [Yup.ref("bollettaEmail"), null],
            <TranslatedText i18nKey="cases.request_info.email.match" />
          )
          .required(bollettaComune.requiredErrorMsg),
      }),


      [bollettaComune.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(bollettaComune.requiredErrorMsg),

      [bollettaProvincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(bollettaProvincia.requiredErrorMsg),

      [bollettaFisso.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationPhone, { message: bollettaFisso.invalidErrorMsg }),
      [bollettaPec.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationEmail, { message: bollettaPec.invalidErrorMsg }),
    }),

    // step 4.1
    Yup.object().shape({
      [datiImmobile_cognomeNomeRecapito.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationBusinessName.regex
          , {
            message: (
              <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
            ),
          })
        .required(datiImmobile_cognomeNomeRecapito.requiredErrorMsg),
      [datiImmobile_cap.name]: Yup.string()
        .required(<TranslatedText i18nKey="errors.registration.public.fc.required" />),
      [datiImmobile_partitaIva.name]: Yup.string()
        .min(11, <TranslatedText i18nKey="errors.registration.public.fc.short" />)
        .max(11, <TranslatedText i18nKey="errors.registration.public.fc.long" />)
        .matches(validationNumber, { message: <TranslatedText i18nKey="cases.request_info.fields.partitaIva.invalid" /> }),
      [datiImmobile_codiceFiscale.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationFiscalCode, { message: <TranslatedText i18nKey="errors.registration.public.fc.match" /> }),
      [datiImmobile_fisso.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationPhone, {
          message: <TranslatedText i18nKey="errors.user.profile.validate.cellphone.invalid" />
        }),
      [datiImmobile_comune.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(datiImmobile_comune.requiredErrorMsg),
      [datiImmobile_provincia.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .required(datiImmobile_provincia.requiredErrorMsg),
      [datiImmobile_cellulare.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationPhone, { message: <TranslatedText i18nKey="errors.user.profile.validate.cellphone.invalid" /> })
        .required(datiImmobile_cellulare.requiredErrorMsg),
      [datiImmobile_email.name]: Yup.string()
        .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
        .matches(validationEmail, { message: datiImmobile_email.invalidErrorMsg })
        .required(datiImmobile_email.requiredErrorMsg),
    }),

    // step 4.2
    Yup.object().shape({
      [inQualitaDi.name]: Yup.string()
        .oneOf(inQualitaDi.options.map(option => option.value), <TranslatedText i18nKey="common.errors.notValid" />)
        .required(<TranslatedText i18nKey="cases.request_info.errors.required" />),
      [ilSottoscrittoNome.name]: Yup.string()
        .when(inQualitaDi.name, {
          is: (field) => field === AccountHolderType.OWNER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(ilSottoscrittoNome.requiredErrorMsg)
        }),
      [ilSottoscrittoCognome.name]: Yup.string()
        .when(inQualitaDi.name, {
          is: (field) => field === AccountHolderType.OWNER,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />).strict(true)
            .required(ilSottoscrittoCognome.requiredErrorMsg)
        }),
      [dichiaro_diEssereIntestatario_numero.name]: Yup.string()
        .when(dichiaro_diEssereIntestatario.name, {
          is: true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_diEssereIntestatario_data.name]: Yup.string()
        .when(dichiaro_diEssereIntestatario.name, {
          is: true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_rilasciatoPermesso_numero.name]: Yup.string()
        .when(dichiaro_rilasciatoPermesso.name, {
          is: true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_rilasciatoPermesso_data.name]: Yup.string()
        .when(dichiaro_rilasciatoPermesso.name, {
          is: (field) => field === true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_presentataDia_numero.name]: Yup.string()
        .when(dichiaro_presentataDia.name, {
          is: (field) => field === true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_presentataDia_data.name]: Yup.string().when(dichiaro_presentataDia.name, {
        is: (field) => field === true,
        then: Yup.string().required(
          <TranslatedText i18nKey="errors.registration.public.fc.required" />
        ),
      }),
      [dichiaro_presentataScia_numero.name]: Yup.string()
        .when(dichiaro_presentataScia.name, {
          is: true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }
        ),
      [dichiaro_presentataScia_data.name]: Yup.string()
        .when(dichiaro_presentataScia.name, {
          is: true,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        }),
      [dichiaro_altro.name]: Yup.string()
        .when(inQualitaDi.name, {
          is: (field) => field === AccountHolderType.OTHER,
          then: Yup.string().required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
        })
    }).test('myCustomTest', null, (value) => {
      if (value.dichiaro_diEssereIntestatario
        || value.dichiaro_rilasciatoPermesso
        || value.dichiaro_presentataDia
        || value.dichiaro_presentataScia
        || value.dichiaro_dataCostruzioneIdonea
        || value.dichiaro_altro
        || value.inQualitaDi !== AccountHolderType.OWNER
      ) {
        return true; // everything is fine
      }
      return new Yup.ValidationError(
        <TranslatedText i18nKey="cases.allacciamento.richiesta_allacciamento.selection.error_message" />,
        null
      )
    }),

    //ste 4.3
    Yup.object().shape({
      [tipologiaUso.name]: Yup.string()
        .oneOf(tipologiaUso.options.map(option => option.value), <TranslatedText i18nKey="common.errors.notValid" />)
        .required(<TranslatedText i18nKey="cases.request_info.errors.required" />),
      [tipologiaUso_immissione.name]: Yup.string()
        .oneOf(tipologiaUso_immissione.options.map(option => option.value), <TranslatedText
          i18nKey="common.errors.notValid" />)
        .required(tipologiaUso_immissione.requiredErrorMsg),
      [tipologiaUso.name]: Yup.string().required(tipologiaUso.requiredErrorMsg),
      [tipologiaUso_utenza.name]: Yup.string().when([tipologiaUso.name, userRole.name], {
        is: (tipologiaUso, userRole) => tipologiaUso === SupplyUserType.AQUEDUCT && userRole !== UserRoleEnum.MUNICIPAL_OPERATOR,
        then: Yup.string().required(tipologiaUso_utenza.requiredErrorMsg),
      }),
      [tipologiaUso_utenza_input.name]: Yup.string().when([tipologiaUso.name, userRole.name], {
        is: (tipologiaUso, userRole) => tipologiaUso === SupplyUserType.AQUEDUCT && userRole === UserRoleEnum.MUNICIPAL_OPERATOR,
        then: Yup.string().required(tipologiaUso_utenza_input.requiredErrorMsg),
      }),
    }),

    Yup.object().shape({
      [estremiDelDocumento1.name]: Yup.string().when([signValue.name,], {
        is: (signValue) => signValue === false,
        then: Yup.string()
          .trim(<TranslatedText i18nKey="common.empty_characters" />)
          .strict(true)
          .required(
            <TranslatedText i18nKey="errors.registration.public.fc.required" />
          ),
      }),
    }),

    Yup.object().shape({}),

    Yup.object().shape({
      [cognomeNomeDelConto.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationBusinessName.regex
              , {
                message: (
                  <TranslatedText i18nKey={validationBusinessName?.message_key || ""} />
                ),
              })
            .required(cognomeNomeDelConto.requiredErrorMsg),
        }
      ),
      [codiceFiscaleTitolare.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationFiscalCode, {
              message: codiceFiscaleTitolare.invalidErrorMsg,
            })
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [cellulareDomiciliazione.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: (
                <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
              ),
            })
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [telefonoDomiciliazione.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .matches(validationPhone, {
              message: (
                <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
              ),
            }),
        }
      ),
      [bankName.name]: Yup.string().when(
        bollettaAddebitoBancario.name,
        {
          is: true,
          then: Yup.string()
            .trim(<TranslatedText i18nKey="common.empty_characters" />)
            .strict(true)
            .required(
              <TranslatedText i18nKey="errors.registration.public.fc.required" />
            ),
        }
      ),
      [iban.name]: Yup.string().when(bollettaAddebitoBancario.name, {
        is: true,
        then: Yup.string()
          .required(iban.requiredErrorMsg)
          .min(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .max(27, (<TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_length" />))
          .matches(/[A-Z]/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_characters_check" />
            ),
          })
          .matches(/IT[A-Z0-9]{2}\s?/, {
            message: (
              <TranslatedText i18nKey="cases.domiciliazone_bancaria.iban_digits" />
            )
          }),
      }),

    }),

    Yup.object().shape({
      [estremiDelDocumento.name]: Yup.string().required(estremiDelDocumento.requiredErrorMsg),
      [idType.name]: Yup.string()
        .oneOf(
          idType.options.map((option) => option.value),
          <TranslatedText i18nKey="common.errors.notValid" />
        )
        .required(
          <TranslatedText i18nKey="cases.request_info.errors.required" />
        ),
      [ID.name]: Yup.mixed()
        .required(<TranslatedText i18nKey="cases.errors.required" />)
        .test("fileSize", "Your file", (value) => value && value !== undefined),
      [fattura.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) =>
          field === AccountHolderType.OTHER,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [Legittima.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) =>
          field === AccountHolderType.CONDOMINIUM_ADMIN ||
          field === AccountHolderType.USUFRUCTUARY ||
          field === AccountHolderType.TENANT ||
          field === AccountHolderType.LEGAL_REPRESENTATIVE ||
          field === AccountHolderType.OTHER,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [codiceFiscaleDoc.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [verbale.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.CONDOMINIUM_ADMIN,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
      [CCIAA.name]: Yup.mixed().when(inQualitaDi.name, {
        is: (field) => field === AccountHolderType.LEGAL_REPRESENTATIVE,
        then: Yup.mixed()
          .required(<TranslatedText i18nKey="cases.errors.required" />)
          .test(
            "fileSize",
            "Your file",
            (value) => value && value !== undefined
          ),
      }),
    }),
  ]
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.fognatura.step1_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.fognatura.step1_1.title" />,
      fields: [
        {
          fieldName: comuneAllaccio.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: via.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: numeroCivico.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: tipologiaAllaccio.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
      ],
    },
    {
      chapter: false,
      chapterName: (
        <TranslatedText i18nKey="cases.fognatura.step1_2.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.fognatura.step1_2.title" />,

      fields: [
        {
          fieldName: "tipoIntestatario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "fisicaNome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCognome",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaNatoA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaDataNascita",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaSesso",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaIndirizzoResidenza",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaComuneResidenza",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaProvincia",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "fisicaCAP",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.NATURAL,
            },
          ],
        },
        {
          fieldName: "giuridicaRagioneSociale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCodiceFiscale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: false,
            }
          ],
        },
        {
          fieldName: "giuridicaPartitaIVA2",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        }, {
          fieldName: "giuridicaPartitaIVAGrupoCheckbox",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
          className: "align-self-center"
        },
        {
          fieldName: "giuridicaPartitaIVAGrupo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },
        {
          fieldName: null,
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
            {
              if: "giuridicaPartitaIVAGrupoCheckbox",
              is: true,
            }
          ],
        },

        {
          fieldName: "giuridicaName",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaSurname",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaSedeLegaleIndirizzo",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaComune",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaProvincia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
        {
          fieldName: "giuridicaCAP",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "tipoIntestatario",
              is: PersonType.LEGAL,
            },
          ],
        },
      ],
    },
    // step 2.1
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.fognatura.step2_1.chapterName" />,
      title: <TranslatedText i18nKey="cases.fognatura.step2_1.title" />,
      component: FatturazioneElettronica,
      fields: [
        {
          fieldName: 'codiceDestinatarioSDI',
          grid: {
            xs: 12,
            md: 6,
          },

          condition: [

            {
              if: null,
              is: UserRoleEnum.PRIVATE
            }, {
              if: null,
              is: UserRoleEnum.COMPANY
            }, {
              if: null,
              is: UserRoleEnum.CONDOMINIUM_ADMIN
            }, {
              if: null,
              is: UserRoleEnum.MANAGER
            }, {
              if: null,
              is: UserRoleEnum.OPERATOR
            }, {
              if: null,
              is: UserRoleEnum.PARTNER
            }, {
              if: null,
              is: UserRoleEnum.MUNICIPAL_OPERATOR
            }]
        },
        {
          fieldName: 'codiceDestinatarioPA',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER
          }]
        },
        {
          fieldName: 'indirizzoPEC',
          grid: {
            xs: 12,
            md: 6,
          }
        },
        {
          fieldName: 'codiceCIG',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER
          }]
        },
        {
          fieldName: 'codiceCUP',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER
          }]
        },
        {
          fieldName: 'splitPaymentCat',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: null,
            is: UserRoleEnum.MUNICIPAL_USER
          }]
        },
      ],
    },
    // step 3.1
    {
      chapter: true,
      chapterName: (<TranslatedText i18nKey="cases.fognatura.step3_1.chapterName" />),
      title: (
        <div className="case-step-title mb-5">
          <TranslatedText i18nKey="cases.fognatura.step3_1.title" />
        </div>
      ),
      component: DigitalizzazioneDocument,
      hooks: {
        pre: (values, setFieldValue) => {
          if (values[tipoIntestatario.name] === PersonType.NATURAL) {
            setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[fisicaComuneResidenza.name], values[fisicaProvincia.name], values[fisicaCAP.name], values[fisicaIndirizzoResidenza.name]))
          } else {
            setFieldValue('bollettaDatiIntestatario', getStandardAddressFormat("cases.address_suggestion.button_2", values[giuridicaComune.name], values[giuridicaProvincia.name], values[giuridicaCAP.name], values[giuridicaSedeLegaleIndirizzo.name]))
          }
        },
      },
      fields: [
        {
          fieldName: 'bollettaRecapitoTipo',
          grid: {
            md: 6,
            xs: 12
          },
        },
        // New Address
        {
          fieldName: 'bollettaRecapitoNuovoIndirizzo',
          grid: {
            md: 6,
            xs: 12
          },
        },
        // Existing address
        {
          fieldName: 'bollettaPuntoDiFurnitura',
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaDatiIntestatario',
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaIndirizzo',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaComune',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaCap',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaProvincia',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: "bollettaNomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: "bollettaCognomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: 'bollettaCellulare',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaFisso',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaEmail',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: "bollettaConfirmEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info" />}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.PRE_ESISTENTE,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: 'bollettaPec',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.PRE_ESISTENTE
          }]
        },
        {
          fieldName: 'bollettaIndirizzo',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: 'bollettaComune',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: 'bollettaCap',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: 'bollettaProvincia',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: "bollettaNomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: "bollettaCognomePresso",
          grid: {
            xs: 12,
            md: 6
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
          ],
          className: "padding-50",
        },
        {
          fieldName: 'bollettaCellulare',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: 'bollettaFisso',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: 'bollettaEmail',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
        {
          fieldName: "bollettaConfirmEmail",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={<TranslatedText i18nKey="cases.confirm.email.info" />}
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaRecapitoTipo",
              is: TipoBollettaRecapito.NUOVO,
            },
            (() => {
              const obj = {
                if: "sign",
              };
              Object.defineProperty(obj, "is", {
                get: function () {
                  return sign;
                },
              });
              return obj;
            })(),
          ],
        },
        {
          fieldName: 'bollettaPec',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'bollettaRecapitoTipo',
            is: TipoBollettaRecapito.NUOVO
          }]
        },
      ],
    },
    // step 4.1
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.fognatura.step4_1.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.fognatura.step4_1.title" />,
      fields: [
        {
          fieldName: datiImmobile_cognomeNomeRecapito.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_codiceFiscale.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_partitaIva.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_indirizzoCivico.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: datiImmobile_comune.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_cap.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_provincia.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_cellulare.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_fisso.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
        {
          fieldName: datiImmobile_email.name,
          grid: {
            xs: 12,
            md: 4,
          },
        },
      ],
    },
    //step 4.2
    {
      chapter: false,
      title: 'Richiesta allacciamento',
      className: "step-4",
      fields: [
        {
          fieldName: null,
          text: <PlainLabel label={<TranslatedText i18nKey='cases.fognatura.step4_2.other.ilSotoscritto' />} />,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: 'inQualitaDi',
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.labels.ownership_details' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
        },
        {
          fieldName: null,
          text: <PlainLabel label={<TranslatedText i18nKey='cases.voltura.labels.dichiarazione_sostitutiva' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
        },
        {
          fieldName: 'inQualitaDi_altro',
          text: <TranslatedText i18nKey="cases.fognatura.step4_2.inQualitaDi_altro.placeholder" />,
          className: "",
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OTHER
          }],
        },
        {
          fieldName: null,
          text: (
            <PlainLabel
              label={
                <TranslatedText i18nKey="allacimanento_altro_message" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },

        {
          fieldName: 'ilSottoscrittoNome',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
        },
        {
          fieldName: 'ilSottoscrittoCognome',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
        },
        {
          fieldName: null,
          text: <PlainLabel label={<TranslatedText i18nKey='cases.voltura.labels.declaration_request' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
        },
        {
          fieldName: 'dichiaro_diEssereIntestatario',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start checkbox-group-list'
        },

        {
          fieldName: 'dichiaro_diEssereIntestatario_numero',
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input left step-4-3'
        },
        {
          fieldName: null,
          text: <SimpleText text={<TranslatedText i18nKey='common.text.del' />} />,
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start mb-3 text-center'
        },
        {
          fieldName: 'dichiaro_diEssereIntestatario_data',
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input step-4-3'
        },
        {
          fieldName: 'dichiaro_rilasciatoPermesso',
          grid: {
            xs: 12,
            md: 5
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start checkbox-group-list'
        },


        {
          fieldName: 'dichiaro_rilasciatoPermesso_numero',
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input left step-4-3'
        },
        {
          fieldName: null,
          text: <SimpleText text={<TranslatedText i18nKey='common.text.del' />} />,
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start mb-3 text-center'
        },
        {
          fieldName: 'dichiaro_rilasciatoPermesso_data',
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input step-4-3'
        },
        {
          fieldName: null,
          text: <SimpleText text={<TranslatedText i18nKey='cases.fognatura.step4.label' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'info-label-simple-text text-md',
        },
        {
          fieldName: 'dichiaro_presentataDia',
          grid: {
            xs: 12,
            md: 4
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start checkbox-group-list'
        },

        {
          fieldName: 'dichiaro_presentataDia_numero',
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input left step-4-3'
        },
        {
          fieldName: null,
          text: <SimpleText text={<TranslatedText i18nKey='common.text.del' />} />,
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start mb-3 text-center'
        },
        {
          fieldName: 'dichiaro_presentataDia_data',
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input step-4-3'
        },

        {
          fieldName: 'dichiaro_presentataScia',
          grid: {
            xs: 12,
            md: 5
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start checkbox-group-list'
        },

        {
          fieldName: 'dichiaro_presentataScia_numero',
          grid: {
            xs: 10,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input left step-4-3'
        },
        {
          fieldName: null,
          text: <SimpleText text={<TranslatedText i18nKey='common.text.del' />} />,
          grid: {
            xs: 2,
            md: 1,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start mb-3 text-center'
        },
        {
          fieldName: 'dichiaro_presentataScia_data',
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input step-4-3'
        },
        {
          fieldName: 'dichiaro_dataCostruzioneIdonea',
          grid: {
            xs: 12,
            md: 10
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start last-row checkbox-group-list'
        },
        {
          fieldName: 'dichiaro_dataCostruzioneIdonea_data',
          grid: {
            xs: 12,
            md: 2,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.OWNER
          }],
          className: 'align-self-start inline-input step-4-3'
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.titles.labels.affituario' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.TENANT
          }],
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.titles.labels.building_administrator' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.CONDOMINIUM_ADMIN
          }],
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.titles.labels.usufruttuario' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.USUFRUCTUARY
          }],
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.titles.labels.legal_representative' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: AccountHolderType.LEGAL_REPRESENTATIVE
          }],
        },
        {
          fieldName: null,
          text: <InfoLabel label={<TranslatedText i18nKey='cases.voltura.titles.labels.other' />} />,
          grid: {
            xs: 12,
          },
          condition: [{
            if: 'inQualitaDi',
            is: 'ALTRO_TITOLO'
          }],
        },

      ],
    },
    {
      chapter: false,
      component: CombinedConditions,
      chapterName: (
        <TranslatedText i18nKey="cases.fognatura.step4_3.chapterName" />
      ),
      title: <TranslatedText i18nKey="cases.fognatura.step4_3.title" />,
      fields: [
        {
          fieldName: "tipologiaUso",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "tipologiaUso_utenza",
          grid: {
            xs: 12,
            md: 6,
          },
          alternativeCondition: [
            {
              if: 'tipologiaUso',
              is: SupplyUserType.AQUEDUCT
            },
          ],
          condition: [
            {
              if: null,
              is: UserRoleEnum.PRIVATE,
            },
            {
              if: null,
              is: UserRoleEnum.MUNICIPAL_USER,
            },
            {
              if: null,
              is: UserRoleEnum.COMPANY,
            },
            {
              if: null,
              is: UserRoleEnum.CONDOMINIUM_ADMIN,
            },
            {
              if: null,
              is: UserRoleEnum.MANAGER,
            },
            {
              if: null,
              is: UserRoleEnum.OPERATOR,
            },
            {
              if: null,
              is: UserRoleEnum.PARTNER,
            },],
        },
        {
          fieldName: "tipologiaUso_utenza_input",
          grid: {
            xs: 12,
          },
          alternativeCondition: [
            {
              if: 'tipologiaUso',
              is: SupplyUserType.AQUEDUCT
            },
          ],
          condition: [{
            if: null,
            is: UserRoleEnum.MUNICIPAL_OPERATOR,
          }],
        },
        {
          fieldName: "tipologiaUso_immissione",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.fognatura.step4_3.spiegazione" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },
    // step 5.1
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.fognatura.step5_2.chapterName" />,
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.fognatura.step5_2.title" />,
      fields: [
        {
          fieldName: null,
          text: <div className="declaration">
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_1" />
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_2" />
            </p>
            <p>
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.declaration_3" />
            </p>
          </div>,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: "estremiDelDocumento1",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: 'signValue',
              is: false,
            },
          ],

        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: 'signValue',
              is: false,
            },
          ],

        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.title" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="conditions">
              <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.conditions.description" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },

    // step 6
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.fognatura.step8_1.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.fognatura.step8_1.title" />,
      fields: [
        {
          fieldName: null,
          className: 'step-6-1',
          text: (
            <div className="information-privacy">
              <p>
                <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
              </p>
            </div>
          ),
          grid: {
            xs: 12,
          },
        },
      ],
    },
    //step 7
    {
      chapter: true,
      chapterName: (
        <TranslatedText i18nKey="cases.allacciamento.step7_1.chapterName" />
      ),
      noMandatoryLegend: true,
      title: <TranslatedText i18nKey="cases.allacciamento.step7_1.title" />,

      fields: [
        {
          fieldName: "bollettaAddebitoBancario",
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className="checkbox-sub-text">
              <TranslatedText i18nKey="cases.voltura.layout.domiciliazone_bancaria.sub_text" />
            </p>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: null,
          text: (
            <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cognomeNomeDelConto",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleTitolare",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },

        {
          fieldName: "indirizzoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "cellulareDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "telefonoDomiciliazione",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },

        {
          fieldName: "iban",
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "bankName",
          grid: {
            xs: 12,
            md: 8,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
        {
          fieldName: "agencia",
          grid: {
            xs: 12,
            md: 4,
          },
          condition: [
            {
              if: "bollettaAddebitoBancario",
              is: true,
            },
          ],
        },
      ],
    },

    // step 8
    {
      chapter: true,
      chapterName: <TranslatedText i18nKey="cases.digitalization.title" />,
      title: <TranslatedText i18nKey="cases.digitalization.title" />,
      fields: [
        {
          fieldName: "estremiDelDocumento",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <InfoLabel
              label={
                <TranslatedText i18nKey="cases.voltura.layout.dichiarazione_sostitutiva.ricordati" />
              }
            />
          ),
          grid: {
            xs: 12,
          },
          condition: [
            {
              if: signValue,
              is: false,
            }
          ],

        },
        {
          fieldName: "idType",
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "IdType",
              is: ""
            }
          ]
        },
        {
          fieldName: "ID",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence"
          }

        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return (_values["idType"] === "ID" || _values["idType"] === "Passport" || _values["idType"] === "Driving_licence") &&
              (_values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER);
          }

        },
        {
          fieldName: "Legittima",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: (_values) => {
            return _values["inQualitaDi"] === AccountHolderType.CONDOMINIUM_ADMIN || _values["inQualitaDi"] === AccountHolderType.TENANT || _values["inQualitaDi"] === AccountHolderType.USUFRUCTUARY || _values["inQualitaDi"] === AccountHolderType.LEGAL_REPRESENTATIVE || _values["inQualitaDi"] === AccountHolderType.OTHER;
          }
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "codiceFiscaleDoc",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: "verbale",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.CONDOMINIUM_ADMIN,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            }]
        },
        {
          fieldName: "CCIAA",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.LEGAL_REPRESENTATIVE,
            },
          ],
        },
        {
          fieldName: '',
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
        {
          fieldName: "fattura",
          grid: {
            xs: 12,
            md: 6,
          },
          condition: [
            {
              if: "inQualitaDi",
              is: AccountHolderType.OTHER,
            },
          ],
        },
      ],
    },
  ])
}

// Contiene dettagli sul case form
const getFormDetails = (digitalization) => {
  const pdfLink = getCorrectLink(casesInfoFognatura);
  return {
    title: <TranslatedText i18nKey={"cases.fognatura.title"} />,
    description: digitalization ? (<TranslatedText i18nKey={'cases.fognatura.help'} />) : (<a className="link-a"
      href={pdfLink}
      target={"_blank"}
      rel="noopener noreferrer"
    >
      <span className="gc-icon-functional-doc-pdf-2-col" style={{ verticalAlign: "bottom" }}>
        <span className="path1" />
        <span className="path2" />
      </span>{' '}
      {<TranslatedText i18nKey='cases.fognatura.description.info' />}
    </a>),
    stepper: CaseStepperType.Full,
    helpText: digitalization ? (
      <>
        <TranslatedText i18nKey={"cases.allacciamentoFognatura.warn.text"} /><br />
      </>
    ) : (
      <>
        <TranslatedText i18nKey={"cases.allacciamentoFognatura.warn.text"} /><br />
        <TranslatedText i18nKey={'cases.fognatura.help'} /><br />
        <>
          {sign ? (
            <TranslatedText i18nKey="cases.voltura.help_text_1_digitalization" />
          ) : (
            <TranslatedText i18nKey="cases.voltura.help_text_1" />
          )}
          <a className="link" target="_blank" rel="noopener noreferrer" href={`mailto:contratti@gruppocap.it`}>
            contratti@gruppocap.it
          </a> {' '}<br />
          <TranslatedText i18nKey="cases.voltura.help_text_2" />
        </>
      </>
    ),
    successText: (
      <>
        <p>
          <TranslatedText i18nKey="cases.voltura.success_text_1" />{' '}
          <a className="link" target="_blank" rel="noopener noreferrer" href={`mailto:contratti@gruppocap.it`}>
            contratti@gruppocap.it
          </a> {' '}
          <TranslatedText i18nKey="cases.voltura.success_text_3" />
        </p>
      </>
    ),
    incompleteActivation: true,
    summary: true,
    autoOpenHelpModal: true,
  }
};
const punctualizationMapping = (payload) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;

  return {
    toSign: false,
    // attachments: [
    //   payload[inQualitaDi.name] !== AccountHolderType.OWNER ? ({
    //     data: payload[Legittima.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
    //     data: payload[codiceFiscaleDoc.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
    //     data: payload[verbale.name]
    //   }): null,
    //   payload[inQualitaDi.name] === AccountHolderType.LEGAL_REPRESENTATIVE ? ({
    //     data: payload[CCIAA.name]
    //   }): null,
    //   payload[case_2.name] === 'PRESE_ANTINCENDIO' ?({
    //     data: payload[dichiarazione.name]
    //   }) : null,
    //   {
    //     data: payload[ID.name]
    //   },
    // ],
    accountHolder: {
      personType: payload[tipoIntestatario.name],
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaName.name],
      surname: NATURAL ? payload[fisicaCognome.name] : payload[giuridicaSurname.name],
      ...(!NATURAL && { businessName: payload[giuridicaRagioneSociale.name] }),
      fiscalCode: NATURAL ? payload[fisicaCodiceFiscale.name] : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && { birthPlace: payload[fisicaNatoA.name] }),
      ...(NATURAL && { birthDate: moment(payload[fisicaDataNascita.name]).format('DD/MM/yyyy') }),
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      holderType: payload[inQualitaDi.name],
      holderOther: payload[inQualitaDi_altro.name],
      address: {
        city: NATURAL ? payload[fisicaComuneResidenza.name] : payload[giuridicaComune.name],
        postalCode: NATURAL ? payload[fisicaCAP.name] : payload[giuridicaCAP.name],
        province: NATURAL ? payload[fisicaProvincia.name] : payload[giuridicaProvincia.name],
        street: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[0] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[0] || "",
        streetNumber: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[1] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      billing: {
        cigCode: payload[codiceCIG.name],
        cupCode: payload[codiceCUP.name],
        paCode: payload[codiceDestinatarioPA.name],
        pec: payload[indirizzoPEC.name],
        sdiCode: payload[codiceDestinatarioSDI.name],
        splitPaymentCat: payload[splitPaymentCat.name],
      },
      contactsInfo: {
        addressRecapito: {
          city: payload[bollettaComune.name],
          street: payload[bollettaIndirizzo.name].split(',')[0] || "",
          streetNumber: payload[bollettaIndirizzo.name].split(',')[1] || "",
          postalCode: payload[bollettaCap.name],
          province: payload[bollettaProvincia.name],
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
        },
        mobilePhoneNumber: payload[bollettaCellulare.name],
        ...(payload[bollettaFisso.name] && { landlinePhoneNumber: payload[bollettaFisso.name] }),
        email: payload[bollettaEmail.name],
        pec: payload[bollettaPec.name],
      },
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      owner: payload[cognomeNomeDelConto.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      bankName: payload[bankName.name],
      address: payload[indirizzoDomiciliazione.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      bankBranch: payload[agencia.name],
      iban: payload[iban.name],
    },
    newContract: {
      puf: {
        city: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[comuneAllaccio.name] : payload["comune"],
        street: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[via.name] : payload["contractStreet"],
        streetNumber: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[numeroCivico.name] : payload["contractStreetNumber"],
      },
      building: {
        nameSurname: payload[datiImmobile_cognomeNomeRecapito.name],
        fiscalCode: payload[datiImmobile_codiceFiscale.name],
        vatNumber: payload[datiImmobile_partitaIva.name],
        address: payload[datiImmobile_indirizzoCivico.name],
        city: payload[datiImmobile_comune.name.name],
        postalCode: payload[datiImmobile_cap.name],
        province: payload[datiImmobile_provincia.name],
        mobilePhoneNumber: payload[datiImmobile_cellulare.name],
        ...(payload[datiImmobile_fisso.name] && { landlinePhoneNumber: payload[datiImmobile_fisso.name] }),
        email: payload[datiImmobile_email.name],
      },
      ...(payload[inQualitaDi.name] === AccountHolderType.OWNER && {
        declaration: {
          undersigned: `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]}`,
          acts: [{
            type: DeclarationType.OWNER,
            enabled: payload[dichiaro_diEssereIntestatario.name],
            number: payload[dichiaro_diEssereIntestatario_numero.name],
            date: moment(payload[dichiaro_diEssereIntestatario_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.BUILDING,
            enabled: payload[dichiaro_rilasciatoPermesso.name],
            number: payload[dichiaro_rilasciatoPermesso_numero.name],
            date: moment(payload[dichiaro_rilasciatoPermesso_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.DIA,
            enabled: payload[dichiaro_presentataDia.name],
            number: payload[dichiaro_presentataDia_numero.name],
            date: moment(payload[dichiaro_presentataDia_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.SCIA,
            enabled: payload[dichiaro_presentataScia.name],
            number: payload[dichiaro_presentataScia_numero.name],
            date: moment(payload[dichiaro_presentataScia_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.HOUSE_AGE,
            enabled: payload[dichiaro_dataCostruzioneIdonea.name],
            date: moment(payload[dichiaro_dataCostruzioneIdonea_data.name]).format('DD/MM/yyyy'),
          }],
        },
      }),
      supply: {
        useType: payload[tipologiaUso.name],
        userNumber: payload[userRole.name] !== UserRoleEnum.MUNICIPAL_OPERATOR ? payload[tipologiaUso_utenza.name] : payload[tipologiaUso_utenza_input.name],
        water: payload[tipologiaUso_immissione.name],
        integraClientCode: payload[integraClientCode.name]
      },
      identityCardCode: payload[estremiDelDocumento1.name],
    },
    addressList : [
      NATURAL ? model.formField.fisicaIndirizzoResidenza.egonCodeResponse :  model.formField.giuridicaSedeLegaleIndirizzo.egonCodeResponse,
      model.formField.bollettaIndirizzo.egonCodeResponse,
      model.formField.via.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: CaseForms.Fognatura,
    subType: payload[tipologiaAllaccio.name],
  };
};

const translatedMapping = (payload, excludeProperties) => {
  const NATURAL = payload[tipoIntestatario.name] === PersonType.NATURAL;

  if (excludeProperties) {
    return punctualizationMapping(payload);
  }

  return {
    toSign: true,
    attachments: [
      payload[inQualitaDi.name] !== AccountHolderType.OWNER ? ({
        data: payload[Legittima.name]
      }) : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
        data: payload[codiceFiscaleDoc.name]
      }) : null,
      payload[inQualitaDi.name] === AccountHolderType.CONDOMINIUM_ADMIN ? ({
        data: payload[verbale.name]
      }) : null,
      payload[inQualitaDi.name] === AccountHolderType.LEGAL_REPRESENTATIVE ? ({
        data: payload[CCIAA.name]
      }) : null,
      {
        data: payload[ID.name]
      },
      {
        data: payload[fattura.name]
      },
    ],
    newContract: {
      puf: {
        city: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[comuneAllaccio.name] : payload["comune"],
        street: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[via.name] : payload["contractStreet"],
        streetNumber: payload[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? payload[numeroCivico.name] : payload["contractStreetNumber"],
      },
      building: {
        nameSurname: payload[datiImmobile_cognomeNomeRecapito.name],
        fiscalCode: payload[datiImmobile_codiceFiscale.name],
        vatNumber: payload[datiImmobile_partitaIva.name],
        address: payload[datiImmobile_indirizzoCivico.name],
        city: payload[datiImmobile_comune.name.name],
        postalCode: payload[datiImmobile_cap.name],
        province: payload[datiImmobile_provincia.name],
        mobilePhoneNumber: payload[datiImmobile_cellulare.name],
        ...(payload[datiImmobile_fisso.name] && { landlinePhoneNumber: payload[datiImmobile_fisso.name] }),
        email: payload[datiImmobile_email.name],
      },
      ...(payload[inQualitaDi.name] === AccountHolderType.OWNER && {
        declaration: {
          undersigned: `${payload[ilSottoscrittoCognome.name]} ${payload[ilSottoscrittoNome.name]}`,
          acts: [{
            type: DeclarationType.OWNER,
            enabled: payload[dichiaro_diEssereIntestatario.name],
            number: payload[dichiaro_diEssereIntestatario_numero.name],
            date: moment(payload[dichiaro_diEssereIntestatario_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.BUILDING,
            enabled: payload[dichiaro_rilasciatoPermesso.name],
            number: payload[dichiaro_rilasciatoPermesso_numero.name],
            date: moment(payload[dichiaro_rilasciatoPermesso_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.DIA,
            enabled: payload[dichiaro_presentataDia.name],
            number: payload[dichiaro_presentataDia_numero.name],
            date: moment(payload[dichiaro_presentataDia_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.SCIA,
            enabled: payload[dichiaro_presentataScia.name],
            number: payload[dichiaro_presentataScia_numero.name],
            date: moment(payload[dichiaro_presentataScia_data.name]).format('DD/MM/yyyy'),
          }, {
            type: DeclarationType.HOUSE_AGE,
            enabled: payload[dichiaro_dataCostruzioneIdonea.name],
            date: moment(payload[dichiaro_dataCostruzioneIdonea_data.name]).format('DD/MM/yyyy'),
          }],
        },
      }),
      supply: {
        useType: payload[tipologiaUso.name],
        userNumber: payload[userRole.name] !== UserRoleEnum.MUNICIPAL_OPERATOR ? payload[tipologiaUso_utenza.name] : payload[tipologiaUso_utenza_input.name],
        water: payload[tipologiaUso_immissione.name],
        integraClientCode: payload[integraClientCode.name],
      },
      identityCardCode: payload[estremiDelDocumento.name],
    },
    accountHolder: {
      personType: payload[tipoIntestatario.name],
      name: NATURAL ? payload[fisicaNome.name] : payload[giuridicaName.name],
      surname: NATURAL ? payload[fisicaCognome.name] : payload[giuridicaSurname.name],
      ...(!NATURAL && { businessName: payload[giuridicaRagioneSociale.name] }),
      fiscalCode: NATURAL ? payload[fisicaCodiceFiscale.name] : payload[giuridicaCodiceFiscale.name],
      ...(!NATURAL && { vatNumber: payload[giuridicaPartitaIVAGrupoCheckbox.name] === false ? payload[giuridicaPartitaIVA.name] : payload[giuridicaPartitaIVA2.name] }),
      ...(NATURAL && { birthPlace: payload[fisicaNatoA.name] }),
      ...(NATURAL && { birthDate: moment(payload[fisicaDataNascita.name]).format('DD/MM/yyyy') }),
      ...(NATURAL && { sex: payload[fisicaSesso.name] }),
      holderType: payload[inQualitaDi.name],
      holderOther: payload[inQualitaDi_altro.name],
      address: {
        city: NATURAL ? payload[fisicaComuneResidenza.name] : payload[giuridicaComune.name],
        postalCode: NATURAL ? payload[fisicaCAP.name] : payload[giuridicaCAP.name],
        province: NATURAL ? payload[fisicaProvincia.name] : payload[giuridicaProvincia.name],
        street: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[0] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[0] || "",
        streetNumber: NATURAL ? payload[fisicaIndirizzoResidenza.name].split(',')[1] || "" : payload[giuridicaSedeLegaleIndirizzo.name].split(',')[1] || "",
      },
      vatNumberGroupInfo: {
        enabled: payload[giuridicaPartitaIVAGrupoCheckbox.name],
        value: payload[giuridicaPartitaIVAGrupo.name]
      },
      billing: {
        cigCode: payload[codiceCIG.name],
        cupCode: payload[codiceCUP.name],
        paCode: payload[codiceDestinatarioPA.name],
        pec: payload[indirizzoPEC.name],
        sdiCode: payload[codiceDestinatarioSDI.name],
        splitPaymentCat: payload[splitPaymentCat.name],
      },
      contactsInfo: {
        addressRecapito: {
          city: payload[bollettaComune.name],
          street: payload[bollettaIndirizzo.name].split(',')[0] || "",
          streetNumber: payload[bollettaIndirizzo.name].split(',')[1] || "",
          postalCode: payload[bollettaCap.name],
          province: payload[bollettaProvincia.name],
          name: payload[bollettaNomePresso.name],
          surname: payload[bollettaCognomePresso.name],
        },
        mobilePhoneNumber: payload[bollettaCellulare.name],
        ...(payload[bollettaFisso.name] && { landlinePhoneNumber: payload[bollettaFisso.name] }),
        email: payload[bollettaEmail.name],
        pec: payload[bollettaPec.name],
      },
    },
    bankDomiciliation: {
      enabled: Boolean(payload[bollettaAddebitoBancario.name]),
      owner: payload[cognomeNomeDelConto.name],
      fiscalCode: payload[codiceFiscaleTitolare.name],
      bankName: payload[bankName.name],
      address: payload[indirizzoDomiciliazione.name],
      ...(payload[telefonoDomiciliazione.name] && {
        landlinePhoneNumber: payload[telefonoDomiciliazione.name],
      }),
      ...(Boolean(payload[bollettaAddebitoBancario.name]) && {
        mobilePhoneNumber: payload[cellulareDomiciliazione.name],
      }),
      bankBranch: payload[agencia.name],
      iban: payload[iban.name],
    },
    addressList : [
      NATURAL ? model.formField.fisicaIndirizzoResidenza.egonCodeResponse :  model.formField.giuridicaSedeLegaleIndirizzo.egonCodeResponse,
      model.formField.bollettaIndirizzo.egonCodeResponse,
      model.formField.via.egonCodeResponse,
      model.formField.indirizzoDomiciliazione.egonCodeResponse,
    ].filter(element => element !== undefined && element !== null),
    draft: false,
    type: CaseForms.Fognatura,
    subType: payload[tipologiaAllaccio.name],
  };
};
const translatedInverseMapping = (payload, values, excludeProperties) => {
  const errorsFields = payload.map(({ field, message }) => {
    return { field, message };
  });
  const mapping = {
    "req.accountHolder.address.city": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaComuneResidenza.name : giuridicaComune.name,
    "req.accountHolder.address.province": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaProvincia.name : giuridicaProvincia.name,
    "req.accountHolder.address.postalCode": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCAP.name : giuridicaCAP.name,
    "req.accountHolder.address.street": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,
    "req.accountHolder.address.streetNumber": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaIndirizzoResidenza.name : giuridicaSedeLegaleIndirizzo.name,

    "req.accountHolder.birthDate": fisicaDataNascita.name,
    "req.accountHolder.birthPlace": fisicaNatoA.name,
    "req.accountHolder.businessName": giuridicaRagioneSociale.name,
    "req.accountHolder.fiscalCode": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCodiceFiscale.name : giuridicaCodiceFiscale.name,

    "req.accountHolder.holderOther": inQualitaDi_altro.name,
    "req.accountHolder.holderType": inQualitaDi.name,

    "req.accountHolder.name": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaNome.name : giuridicaName.name,
    "req.accountHolder.personType": tipoIntestatario.name,
    "req.accountHolder.sex": fisicaSesso.name,
    "req.accountHolder.surname": values[tipoIntestatario.name] === PersonType.NATURAL ? fisicaCognome.name : giuridicaSurname.name,
    "req.accountHolder.vatNumber": giuridicaPartitaIVA.name,


    "req.accountHolder.billing.cigCode": codiceCIG.name,
    "req.accountHolder.billing.cupCode": codiceCUP.name,
    "req.accountHolder.billing.paCode": codiceDestinatarioPA.name,
    "req.accountHolder.billing.pec": indirizzoPEC.name,
    "req.accountHolder.billing.sdiCode": codiceDestinatarioSDI.name,
    "req.accountHolder.billing.splitPaymentCat": splitPaymentCat.name,

    "req.accountHolder.contactsInfo.addressRecapito.street": bollettaIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.streetNumber": bollettaIndirizzo.name,
    "req.accountHolder.contactsInfo.addressRecapito.city": bollettaComune.name,
    "req.accountHolder.contactsInfo.addressRecapito.postalCode": bollettaCap.name,
    "req.accountHolder.contactsInfo.addressRecapito.province": bollettaProvincia.name,
    "req.accountHolder.contactsInfo.addressRecapito.name":
      bollettaNomePresso.name,
    "req.accountHolder.contactsInfo.addressRecapito.surname":
      bollettaCognomePresso.name, "req.accountHolder.contactsInfo.mobilePhoneNumber": bollettaCellulare.name,
    "req.accountHolder.contactsInfo.landlinePhoneNumber": bollettaFisso.name,
    "req.accountHolder.contactsInfo.email": bollettaEmail.name,
    "req.accountHolder.contactsInfo.pec": bollettaPec.name,

    "req.newContract.building.nameSurname": datiImmobile_cognomeNomeRecapito.name,
    "req.newContract.building.fiscalCode": datiImmobile_codiceFiscale.name,
    "req.newContract.building.vatNumber": datiImmobile_partitaIva.name,
    "req.newContract.building.address": datiImmobile_indirizzoCivico.name,
    "req.newContract.building.city": datiImmobile_comune.name,
    "req.newContract.building.postalCode": datiImmobile_cap.name,
    "req.newContract.building.province": datiImmobile_provincia.name,
    "req.newContract.building.mobilePhoneNumber": datiImmobile_cellulare.name,
    "req.newContract.building.landlinePhoneNumber": datiImmobile_fisso.name,
    "req.newContract.building.email": datiImmobile_email.name,

    "req.newContract.declaration.undersigned": ilSottoscrittoCognome.name,

    "req.newContract.puf.city": values[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? comuneAllaccio.name : values["comune"],
    "req.newContract.puf.street": values[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? via.name : values["contractStreet"],
    "req.newContract.puf.streetNumber": values[tipologiaUso.name] === SupplyUserType.PRIVATE_WELL ? numeroCivico.name : values["contractStreetNumber.name"],

    "req.newContract.supply.useType": tipologiaUso.name,
    "req.newContract.supply.userNumber": tipologiaUso_utenza.name,
    "req.newContract.supply.water": tipologiaUso_immissione.name,
    "req.newContract.supply.integraClientCode": integraClientCode.name,
    "req.newContract.identityCardCode": estremiDelDocumento.name,

    "req.bankDomiciliation.enabled": bollettaAddebitoBancario.name,
    "req.bankDomiciliation.owner": cognomeNomeDelConto.name,
    "req.bankDomiciliation.fiscalCode": codiceFiscaleTitolare.name,
    "req.bankDomiciliation.bankName": bankName.name,
    "req.bankDomiciliation.address": indirizzoDomiciliazione.name,
    "req.bankDomiciliation.landlinePhoneNumber": telefonoDomiciliazione.name,
    "req.bankDomiciliation.mobilePhoneNumber": cellulareDomiciliazione.name,
    "req.bankDomiciliation.bankBranch": agencia.name,
    "req.bankDomiciliation.iban": iban.name,

    "req.subType": tipologiaAllaccio.name,
  };

  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = item.message;
    return acc;
  }, {});
};

const mutation = {
  type: CaseMutationType.Complex,
};
const getTrackingEventKo = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Fognatura, "step": "invio_richiesta", "esito": "KO" }) };
const getTrackingEvent = () => () => { window.dataLayer.push({ "event": "pratica", "tipo": CaseForms.Fognatura, "step": "invio_richiesta", "esito": "OK" }) };
const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  console.log(excludeSteps, 'excludeSteps')
  const layout = getLayout(privacyLink, privacyCtaLabel);
  sign = signDigital
  let validation = getValidationSchema();
  if (excludeSteps && counter < 1) {
    const stepsExcluded = excludeSteps;
    let deletedLayout = removeRequiredStep(stepsExcluded, layout)
    const { formField } = model;
    validation = removeDeletedLayoutFields(deletedLayout, formField, initialValues, validation)
    model = { ...model, formField }

  }
  return {
    model,
    validationSchema: validation,
    initialValues,
    layout,
    formDetails: getFormDetails(sign),
    trackingEventKo: getTrackingEventKo(),
    trackingEvent: getTrackingEvent(),
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};
export default main;

